import { render, staticRenderFns } from "./editionList.vue?vue&type=template&id=b7551708&scoped=true&"
import script from "./editionList.vue?vue&type=script&lang=js&"
export * from "./editionList.vue?vue&type=script&lang=js&"
import style0 from "./editionList.vue?vue&type=style&index=0&id=b7551708&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7551708",
  null
  
)

export default component.exports